export default function ServiceOfferedTile({
    label,
    value,
    isSelected,
    toggleSelected,
}: {
    label: string;
    value: string;
    isSelected: boolean;
    toggleSelected: (value: string) => void;
}) {
    return (
        <div className="space-y-4">
            <div
                className={`bg-white rounded-lg shadow-sm border transition-all hover:shadow-md ${
                    isSelected ? 'border-primary  ' : 'border-gray-200'
                }`}
                onClick={() => toggleSelected(value)} 
            >
                <div className="p-4 flex items-center justify-between cursor-pointer">
                    <div className="flex items-center space-x-4"
                           onClick={(e) => {
                            e.stopPropagation(); 
                            toggleSelected(value);
                        }}
                        >
                        <div
                            className={`w-6 h-6 rounded border flex items-center justify-center ${
                                isSelected ? 'bg-primary border-primary' : 'border-gray-300 hover:border-primary'
                            }`}
                        >
                            {isSelected && (
                                <svg
                                    className="w-4 h-4 text-white"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path d="M5 13l4 4L19 7" />
                                </svg>
                            )}
                        </div>
                        <span className={`font-medium ${isSelected ? '' : 'text-gray-700'}`}>{label}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}




export const LoadingSkeleton = () => (
    <div className="p-6 ">
        <div className="h-14 w-full mb-6 bg-gray-100 animate-pulse rounded-lg" />
        <div className="grid gap-6 md:grid-cols-1">
            {[...Array(6)].map((_, i) => (
                <div
                    key={i}
                    className="h-16 w-full bg-gray-100 animate-pulse rounded-lg"
                />
            ))}
        </div>
    </div>
);